<!--
 * @Author: your name
 * @Date: 2022-02-11 15:53:47
 * @LastEditTime: 2022-03-15 17:49:18
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jeecg-boot\ant-design-vue-jeecg\src\views\modules\workbench\project\catelog\index.vue
-->
<template>
  <div class="catelog">
    <Logo v-show="device === 'mobile'" />
    <div
      :class="`catelog-item ${curIndex === index ? 'active' : ''}`"
      @click="_leftTab(index)"
      v-for="(item, index) in list"
      :key="item.text"
    >
      <div :class="`iconfont ${item.icon}`"></div>
      <span>{{ item.text }}</span>
    </div>
  </div>
</template>
<script>
import Logo from '@/components/tools/Logo'
import { mixinDevice } from '@/utils/mixin.js'
export default {
  mixins: [mixinDevice],
  components: {
    Logo
  },
  data() {
    return {
      list: [
        {
          icon: 'icon-hezi',
          text: '项目'
        }
      ],
      curIndex: 0
    }
  },
  methods: {
    _leftTab(index) {
      this.curIndex = index
    }
  }
}
</script>
<style lang="less">
@import './index.less';
</style>
